import React, { useState } from 'react';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Row, Col, Card, Checkbox, Input, Button, Select, Typography, Radio } from 'antd';
import './NoResult.css'
import bgImg from '../../../../../assets/icons/chart-colored-bg.png'
import InfoIcon from "../../../../../assets/icons/info.png";
import { ReloadOutlined, UndoOutlined } from '@ant-design/icons';
import CustomIcon from '../../../../../utils/components/CustomIcon/CustomIcon';

const { Title } = Typography;

const NoResult = ({ handleReset }) => {
  return (
    <div className="gs-theme__container">
      <div id="no-result-info-div" className="position-relative" style={{ minHeight: "200px" }}>
        <img src={bgImg} alt="bg-img" className="position-absolute-top-right" />
        <div id="no-result-logo" className="gs-theme__icon-frame">
          <CustomIcon name="Info" width={40} height={40} color="#FFFFFF" />
          {/* <img src={InfoIcon} alt='Application Logo' style={{ height: '40px', width: '40px' }} /> */}
        </div>
        <Title level={2} style={{ margin: 0, color: 'white'}}>0 Potential Diseases Found</Title>
        <Title level={3} style={{ margin: 0, color: 'white'}}>Genetic Test Not Recommended</Title>
      </div>
      <div style={{ padding: '24px' }}>
        <Button type="default" block onClick={handleReset} style={{ background: 'transparent' }}>
          Reset Search<CustomIcon name="Reset" />
        </Button>
      </div>
    </div>
  );
};

export default NoResult;
